import { Helper } from '../Helper';
export class ArrReduceFuncHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getCallable({}));
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'DUP');
        sb.emitOp(node, 'ARRAYSIZE');
        sb.emitPushInt(node, 0);
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'GT');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'DUP');
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'PICK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'PICKITEM');
                sb.emitOp(node, 'SWAP');
                sb.emitHelper(node, options, sb.helpers.wrapNumber);
                sb.emitOp(node, 'SWAP');
                sb.emitPushInt(node, 6);
                sb.emitOp(node, 'ROLL');
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'PACK');
                sb.emitPushInt(node, 4);
                sb.emitOp(node, 'PICK');
                sb.emitHelper(node, sb.pushValueOptions(innerOptions), sb.helpers.call);
                sb.emitPushInt(node, 5);
                sb.emitOp(node, 'XTUCK');
                sb.emitOp(node, 'DROP');
            },
            incrementor: () => {
                sb.emitOp(node, 'INC');
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                if (!optionsIn.pushValue) {
                    sb.emitOp(node, 'DROP');
                }
            },
        }));
    }
}

//# sourceMappingURL=ArrReduceFuncHelper.js.map
